
export const SellerSizeGuidesFullQuery = new TypedDocumentString(`
    query SellerSizeGuidesFullQuery($input: InputPagination!, $sellerId: ObjectId!) {
  publicSizeGuides(input: $input, sellerId: $sellerId) {
    info {
      ...PaginationInfo
      __typename
    }
    items {
      ...SellerSizeGuide
      __typename
    }
    __typename
  }
}
    fragment SellerSizeGuide on SellerSizeGuide {
  _id
  title {
    value
    __typename
  }
  image {
    ...Image
    __typename
  }
  sizes {
    key
    title {
      value
      __typename
    }
    __typename
  }
  areas {
    key
    name
    title {
      value
      __typename
    }
    description {
      value
      __typename
    }
    __typename
  }
  units {
    key
    unit
    __typename
  }
  values {
    sizeKey
    areaKey
    unitKey
    value
    __typename
  }
  instructionsNote {
    value
    __typename
  }
  measurmentsNote {
    value
    __typename
  }
  __typename
}
fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment PaginationInfo on PaginationInfo {
  pageInfo {
    ...PageInfo
    __typename
  }
  sorting {
    name
    field
    __typename
  }
  filters {
    key
    name
    type
    options {
      number {
        min
        max
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}
fragment PageInfo on PageInfo {
  totalCount
  totalPageCount
  pageSize
  currentPage
  hasPrevious
  hasNext
  __typename
}`, {"hash":"20e2f6510cfd54857f36334d3db3032a5b26958e7f4c7d91e8379f9730549fe7"});